"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHENTICATED_CUSTOMER_TOKEN_KEY = exports.CUSTOMER_TOKEN_KEY = void 0;
/**
 * @constant
 * @type {string}
 * @description Chave do cookie que armazena um token JWT após o cliente ser identificado.
 * O JWT contém um identificador único do cliente na Plataforma de Reconhecimento.
 */
exports.CUSTOMER_TOKEN_KEY = 'IDENTIFIED_CUSTOMER_JWT';
/**
 * @constant
 * @type {string}
 * @description Chave do cookie que armazena um token JWT após o cliente ser autenticado pelo MSI.
 * O JWT contém os dados do cliente autenticado na Plataforma de Reconhecimento.
 */
exports.AUTHENTICATED_CUSTOMER_TOKEN_KEY = 'token';
